// Phase 3 methods, identifiers 50 to 65 plus the read-side 130 to 133.
//
// Groups introduce the first real permission model. Every mutation here
// serializes on the conversation lock, because the races that matter — a
// removal against a send, an ownership transfer against a leave, a final invite
// use redeemed twice — are all decided by which transaction takes that lock
// first.

// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file chat/v1/methods_p3.proto (package chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Commit, Conversation, Member, PageInfo, Profile } from "./common_pb";
import { file_chat_v1_common } from "./common_pb";
import type { Topic } from "./events_pb";
import { file_chat_v1_events } from "./events_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v1/methods_p3.proto.
 */
export const file_chat_v1_methods_p3: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v1_common, file_chat_v1_events]);

/**
 * @generated from message chat.v1.CreateGroupRequest
 */
export type CreateGroupRequest = Message<"chat.v1.CreateGroupRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated bytes initial_members = 2;
   */
  initialMembers: Uint8Array[];

  /**
   * ALL_HISTORY or SINCE_JOIN. Fixed at creation; changing it later is an owner
   * action that advances the policy version and invalidates outstanding
   * cursors, because a cursor computed under the old rule would page through
   * the wrong window.
   *
   * @generated from field: string history_policy = 3;
   */
  historyPolicy: string;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreateGroupRequest.
 * Use `create(CreateGroupRequestSchema)` to create a new message.
 */
export const CreateGroupRequestSchema: GenMessage<CreateGroupRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 0);

/**
 * @generated from message chat.v1.CreateGroupResponse
 */
export type CreateGroupResponse = Message<"chat.v1.CreateGroupResponse"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreateGroupResponse.
 * Use `create(CreateGroupResponseSchema)` to create a new message.
 */
export const CreateGroupResponseSchema: GenMessage<CreateGroupResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 1);

/**
 * @generated from message chat.v1.CreateInviteRequest
 */
export type CreateInviteRequest = Message<"chat.v1.CreateInviteRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: uint32 max_uses = 2;
   */
  maxUses: number;

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt: bigint;

  /**
   * @generated from field: bool approval = 4;
   */
  approval: boolean;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreateInviteRequest.
 * Use `create(CreateInviteRequestSchema)` to create a new message.
 */
export const CreateInviteRequestSchema: GenMessage<CreateInviteRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 2);

/**
 * @generated from message chat.v1.CreateInviteResponse
 */
export type CreateInviteResponse = Message<"chat.v1.CreateInviteResponse"> & {
  /**
   * Returned exactly once, at creation. Only a hash is stored, so a database
   * read cannot yield working invitations.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreateInviteResponse.
 * Use `create(CreateInviteResponseSchema)` to create a new message.
 */
export const CreateInviteResponseSchema: GenMessage<CreateInviteResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 3);

/**
 * @generated from message chat.v1.RevokeInviteRequest
 */
export type RevokeInviteRequest = Message<"chat.v1.RevokeInviteRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes token_hash = 2;
   */
  tokenHash: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.RevokeInviteRequest.
 * Use `create(RevokeInviteRequestSchema)` to create a new message.
 */
export const RevokeInviteRequestSchema: GenMessage<RevokeInviteRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 4);

/**
 * @generated from message chat.v1.RevokeInviteResponse
 */
export type RevokeInviteResponse = Message<"chat.v1.RevokeInviteResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.RevokeInviteResponse.
 * Use `create(RevokeInviteResponseSchema)` to create a new message.
 */
export const RevokeInviteResponseSchema: GenMessage<RevokeInviteResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 5);

/**
 * @generated from message chat.v1.JoinConversationRequest
 */
export type JoinConversationRequest = Message<"chat.v1.JoinConversationRequest"> & {
  /**
   * @generated from field: optional string token = 1;
   */
  token?: string | undefined;

  /**
   * @generated from field: optional string public_username = 2;
   */
  publicUsername?: string | undefined;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.JoinConversationRequest.
 * Use `create(JoinConversationRequestSchema)` to create a new message.
 */
export const JoinConversationRequestSchema: GenMessage<JoinConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 6);

/**
 * @generated from message chat.v1.JoinConversationResponse
 */
export type JoinConversationResponse = Message<"chat.v1.JoinConversationResponse"> & {
  /**
   * @generated from field: optional chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: bool pending_approval = 2;
   */
  pendingApproval: boolean;

  /**
   * @generated from field: chat.v1.Commit commit = 3;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.JoinConversationResponse.
 * Use `create(JoinConversationResponseSchema)` to create a new message.
 */
export const JoinConversationResponseSchema: GenMessage<JoinConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 7);

/**
 * @generated from message chat.v1.LeaveConversationRequest
 */
export type LeaveConversationRequest = Message<"chat.v1.LeaveConversationRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 2;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.LeaveConversationRequest.
 * Use `create(LeaveConversationRequestSchema)` to create a new message.
 */
export const LeaveConversationRequestSchema: GenMessage<LeaveConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 8);

/**
 * @generated from message chat.v1.LeaveConversationResponse
 */
export type LeaveConversationResponse = Message<"chat.v1.LeaveConversationResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.LeaveConversationResponse.
 * Use `create(LeaveConversationResponseSchema)` to create a new message.
 */
export const LeaveConversationResponseSchema: GenMessage<LeaveConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 9);

/**
 * @generated from message chat.v1.SetMemberRoleRequest
 */
export type SetMemberRoleRequest = Message<"chat.v1.SetMemberRoleRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes user_id = 2;
   */
  userId: Uint8Array;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: int64 permissions = 4;
   */
  permissions: bigint;

  /**
   * Guards against acting on a stale view of the group's policy. Two admins
   * changing roles concurrently must not silently overwrite each other.
   *
   * @generated from field: int64 expected_policy_version = 5;
   */
  expectedPolicyVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 6;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetMemberRoleRequest.
 * Use `create(SetMemberRoleRequestSchema)` to create a new message.
 */
export const SetMemberRoleRequestSchema: GenMessage<SetMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 10);

/**
 * @generated from message chat.v1.SetMemberRoleResponse
 */
export type SetMemberRoleResponse = Message<"chat.v1.SetMemberRoleResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetMemberRoleResponse.
 * Use `create(SetMemberRoleResponseSchema)` to create a new message.
 */
export const SetMemberRoleResponseSchema: GenMessage<SetMemberRoleResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 11);

/**
 * @generated from message chat.v1.SetBanRequest
 */
export type SetBanRequest = Message<"chat.v1.SetBanRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes user_id = 2;
   */
  userId: Uint8Array;

  /**
   * @generated from field: bool banned = 3;
   */
  banned: boolean;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetBanRequest.
 * Use `create(SetBanRequestSchema)` to create a new message.
 */
export const SetBanRequestSchema: GenMessage<SetBanRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 12);

/**
 * @generated from message chat.v1.SetBanResponse
 */
export type SetBanResponse = Message<"chat.v1.SetBanResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetBanResponse.
 * Use `create(SetBanResponseSchema)` to create a new message.
 */
export const SetBanResponseSchema: GenMessage<SetBanResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 13);

/**
 * @generated from message chat.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"chat.v1.ListMembersRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 14);

/**
 * @generated from message chat.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"chat.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Member members = 1;
   */
  members: Member[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 15);

/**
 * TransferOwnership moves ownership atomically.
 *
 * It requires recent authentication, not merely a valid session: it is
 * irreversible from the previous owner's side, so a stolen unlocked device
 * should not be enough.
 *
 * @generated from message chat.v1.TransferOwnershipRequest
 */
export type TransferOwnershipRequest = Message<"chat.v1.TransferOwnershipRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes target_user_id = 2;
   */
  targetUserId: Uint8Array;

  /**
   * @generated from field: string recent_auth_ticket = 3;
   */
  recentAuthTicket: string;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.TransferOwnershipRequest.
 * Use `create(TransferOwnershipRequestSchema)` to create a new message.
 */
export const TransferOwnershipRequestSchema: GenMessage<TransferOwnershipRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 16);

/**
 * @generated from message chat.v1.TransferOwnershipResponse
 */
export type TransferOwnershipResponse = Message<"chat.v1.TransferOwnershipResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.TransferOwnershipResponse.
 * Use `create(TransferOwnershipResponseSchema)` to create a new message.
 */
export const TransferOwnershipResponseSchema: GenMessage<TransferOwnershipResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 17);

/**
 * @generated from message chat.v1.UpsertTopicRequest
 */
export type UpsertTopicRequest = Message<"chat.v1.UpsertTopicRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes topic_id = 2;
   */
  topicId?: Uint8Array | undefined;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: bool closed = 4;
   */
  closed: boolean;

  /**
   * @generated from field: int64 expected_version = 5;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 6;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.UpsertTopicRequest.
 * Use `create(UpsertTopicRequestSchema)` to create a new message.
 */
export const UpsertTopicRequestSchema: GenMessage<UpsertTopicRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 18);

/**
 * @generated from message chat.v1.UpsertTopicResponse
 */
export type UpsertTopicResponse = Message<"chat.v1.UpsertTopicResponse"> & {
  /**
   * @generated from field: bytes topic_id = 1;
   */
  topicId: Uint8Array;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.UpsertTopicResponse.
 * Use `create(UpsertTopicResponseSchema)` to create a new message.
 */
export const UpsertTopicResponseSchema: GenMessage<UpsertTopicResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 19);

/**
 * @generated from message chat.v1.DeleteTopicRequest
 */
export type DeleteTopicRequest = Message<"chat.v1.DeleteTopicRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes topic_id = 2;
   */
  topicId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 3;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.DeleteTopicRequest.
 * Use `create(DeleteTopicRequestSchema)` to create a new message.
 */
export const DeleteTopicRequestSchema: GenMessage<DeleteTopicRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 20);

/**
 * @generated from message chat.v1.DeleteTopicResponse
 */
export type DeleteTopicResponse = Message<"chat.v1.DeleteTopicResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.DeleteTopicResponse.
 * Use `create(DeleteTopicResponseSchema)` to create a new message.
 */
export const DeleteTopicResponseSchema: GenMessage<DeleteTopicResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 21);

/**
 * @generated from message chat.v1.PollOption
 */
export type PollOption = Message<"chat.v1.PollOption"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: uint32 votes = 3;
   */
  votes: number;
};

/**
 * Describes the message chat.v1.PollOption.
 * Use `create(PollOptionSchema)` to create a new message.
 */
export const PollOptionSchema: GenMessage<PollOption> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 22);

/**
 * @generated from message chat.v1.Poll
 */
export type Poll = Message<"chat.v1.Poll"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: repeated chat.v1.PollOption options = 3;
   */
  options: PollOption[];

  /**
   * @generated from field: bool multiple = 4;
   */
  multiple: boolean;

  /**
   * @generated from field: bool anonymous = 5;
   */
  anonymous: boolean;

  /**
   * @generated from field: bool closed = 6;
   */
  closed: boolean;

  /**
   * @generated from field: int64 version = 7;
   */
  version: bigint;

  /**
   * @generated from field: repeated bytes my_votes = 8;
   */
  myVotes: Uint8Array[];

  /**
   * Returned only to the creator, to a voter who has already voted, or after
   * closure. Sending it earlier would give away a quiz answer.
   *
   * @generated from field: optional bytes correct_option = 9;
   */
  correctOption?: Uint8Array | undefined;

  /**
   * @generated from field: optional string explanation = 10;
   */
  explanation?: string | undefined;
};

/**
 * Describes the message chat.v1.Poll.
 * Use `create(PollSchema)` to create a new message.
 */
export const PollSchema: GenMessage<Poll> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 23);

/**
 * @generated from message chat.v1.CreatePollRequest
 */
export type CreatePollRequest = Message<"chat.v1.CreatePollRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: repeated string options = 3;
   */
  options: string[];

  /**
   * @generated from field: bool multiple = 4;
   */
  multiple: boolean;

  /**
   * @generated from field: bool anonymous = 5;
   */
  anonymous: boolean;

  /**
   * @generated from field: optional uint32 correct_index = 6;
   */
  correctIndex?: number | undefined;

  /**
   * @generated from field: optional string explanation = 7;
   */
  explanation?: string | undefined;

  /**
   * @generated from field: optional int64 closes_at = 8;
   */
  closesAt?: bigint | undefined;

  /**
   * @generated from field: bytes client_op_id = 9;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreatePollRequest.
 * Use `create(CreatePollRequestSchema)` to create a new message.
 */
export const CreatePollRequestSchema: GenMessage<CreatePollRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 24);

/**
 * @generated from message chat.v1.CreatePollResponse
 */
export type CreatePollResponse = Message<"chat.v1.CreatePollResponse"> & {
  /**
   * @generated from field: chat.v1.Poll poll = 1;
   */
  poll?: Poll | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreatePollResponse.
 * Use `create(CreatePollResponseSchema)` to create a new message.
 */
export const CreatePollResponseSchema: GenMessage<CreatePollResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 25);

/**
 * @generated from message chat.v1.VoteRequest
 */
export type VoteRequest = Message<"chat.v1.VoteRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes poll_id = 2;
   */
  pollId: Uint8Array;

  /**
   * @generated from field: repeated bytes option_ids = 3;
   */
  optionIds: Uint8Array[];

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.VoteRequest.
 * Use `create(VoteRequestSchema)` to create a new message.
 */
export const VoteRequestSchema: GenMessage<VoteRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 26);

/**
 * @generated from message chat.v1.VoteResponse
 */
export type VoteResponse = Message<"chat.v1.VoteResponse"> & {
  /**
   * @generated from field: chat.v1.Poll poll = 1;
   */
  poll?: Poll | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.VoteResponse.
 * Use `create(VoteResponseSchema)` to create a new message.
 */
export const VoteResponseSchema: GenMessage<VoteResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 27);

/**
 * @generated from message chat.v1.ClosePollRequest
 */
export type ClosePollRequest = Message<"chat.v1.ClosePollRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes poll_id = 2;
   */
  pollId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 3;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.ClosePollRequest.
 * Use `create(ClosePollRequestSchema)` to create a new message.
 */
export const ClosePollRequestSchema: GenMessage<ClosePollRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 28);

/**
 * @generated from message chat.v1.ClosePollResponse
 */
export type ClosePollResponse = Message<"chat.v1.ClosePollResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.ClosePollResponse.
 * Use `create(ClosePollResponseSchema)` to create a new message.
 */
export const ClosePollResponseSchema: GenMessage<ClosePollResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 29);

/**
 * @generated from message chat.v1.ResolveJoinRequestRequest
 */
export type ResolveJoinRequestRequest = Message<"chat.v1.ResolveJoinRequestRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes requester_id = 2;
   */
  requesterId: Uint8Array;

  /**
   * @generated from field: bool approve = 3;
   */
  approve: boolean;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.ResolveJoinRequestRequest.
 * Use `create(ResolveJoinRequestRequestSchema)` to create a new message.
 */
export const ResolveJoinRequestRequestSchema: GenMessage<ResolveJoinRequestRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 30);

/**
 * @generated from message chat.v1.ResolveJoinRequestResponse
 */
export type ResolveJoinRequestResponse = Message<"chat.v1.ResolveJoinRequestResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.ResolveJoinRequestResponse.
 * Use `create(ResolveJoinRequestResponseSchema)` to create a new message.
 */
export const ResolveJoinRequestResponseSchema: GenMessage<ResolveJoinRequestResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 31);

/**
 * @generated from message chat.v1.SetConversationPolicyRequest
 */
export type SetConversationPolicyRequest = Message<"chat.v1.SetConversationPolicyRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 2;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: uint32 slow_mode_seconds = 3;
   */
  slowModeSeconds: number;

  /**
   * @generated from field: bool protected_content = 4;
   */
  protectedContent: boolean;

  /**
   * @generated from field: string history_policy = 5;
   */
  historyPolicy: string;

  /**
   * @generated from field: bytes client_op_id = 6;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetConversationPolicyRequest.
 * Use `create(SetConversationPolicyRequestSchema)` to create a new message.
 */
export const SetConversationPolicyRequestSchema: GenMessage<SetConversationPolicyRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 32);

/**
 * @generated from message chat.v1.SetConversationPolicyResponse
 */
export type SetConversationPolicyResponse = Message<"chat.v1.SetConversationPolicyResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetConversationPolicyResponse.
 * Use `create(SetConversationPolicyResponseSchema)` to create a new message.
 */
export const SetConversationPolicyResponseSchema: GenMessage<SetConversationPolicyResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 33);

/**
 * @generated from message chat.v1.ListTopicsRequest
 */
export type ListTopicsRequest = Message<"chat.v1.ListTopicsRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListTopicsRequest.
 * Use `create(ListTopicsRequestSchema)` to create a new message.
 */
export const ListTopicsRequestSchema: GenMessage<ListTopicsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 34);

/**
 * @generated from message chat.v1.ListTopicsResponse
 */
export type ListTopicsResponse = Message<"chat.v1.ListTopicsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Topic topics = 1;
   */
  topics: Topic[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListTopicsResponse.
 * Use `create(ListTopicsResponseSchema)` to create a new message.
 */
export const ListTopicsResponseSchema: GenMessage<ListTopicsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 35);

/**
 * @generated from message chat.v1.GetPollRequest
 */
export type GetPollRequest = Message<"chat.v1.GetPollRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes poll_id = 2;
   */
  pollId: Uint8Array;
};

/**
 * Describes the message chat.v1.GetPollRequest.
 * Use `create(GetPollRequestSchema)` to create a new message.
 */
export const GetPollRequestSchema: GenMessage<GetPollRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 36);

/**
 * @generated from message chat.v1.GetPollResponse
 */
export type GetPollResponse = Message<"chat.v1.GetPollResponse"> & {
  /**
   * @generated from field: chat.v1.Poll poll = 1;
   */
  poll?: Poll | undefined;
};

/**
 * Describes the message chat.v1.GetPollResponse.
 * Use `create(GetPollResponseSchema)` to create a new message.
 */
export const GetPollResponseSchema: GenMessage<GetPollResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 37);

/**
 * @generated from message chat.v1.ListJoinRequestsRequest
 */
export type ListJoinRequestsRequest = Message<"chat.v1.ListJoinRequestsRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListJoinRequestsRequest.
 * Use `create(ListJoinRequestsRequestSchema)` to create a new message.
 */
export const ListJoinRequestsRequestSchema: GenMessage<ListJoinRequestsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 38);

/**
 * @generated from message chat.v1.ListJoinRequestsResponse
 */
export type ListJoinRequestsResponse = Message<"chat.v1.ListJoinRequestsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Profile users = 1;
   */
  users: Profile[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListJoinRequestsResponse.
 * Use `create(ListJoinRequestsResponseSchema)` to create a new message.
 */
export const ListJoinRequestsResponseSchema: GenMessage<ListJoinRequestsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 39);

/**
 * @generated from message chat.v1.UpdateConversationRequest
 */
export type UpdateConversationRequest = Message<"chat.v1.UpdateConversationRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string public_username = 3;
   */
  publicUsername?: string | undefined;

  /**
   * @generated from field: int64 expected_version = 4;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;

  /**
   * The conversation photo. Absent leaves the current one alone; an explicitly
   * empty value clears it. A bare bytes field could not express the difference,
   * which is why it is optional and why clearing is the empty case rather than a
   * separate flag.
   *
   * @generated from field: optional bytes photo_media_id = 6;
   */
  photoMediaId?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.UpdateConversationRequest.
 * Use `create(UpdateConversationRequestSchema)` to create a new message.
 */
export const UpdateConversationRequestSchema: GenMessage<UpdateConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 40);

/**
 * @generated from message chat.v1.UpdateConversationResponse
 */
export type UpdateConversationResponse = Message<"chat.v1.UpdateConversationResponse"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.UpdateConversationResponse.
 * Use `create(UpdateConversationResponseSchema)` to create a new message.
 */
export const UpdateConversationResponseSchema: GenMessage<UpdateConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p3, 41);

/**
 * @generated from enum chat.v1.MethodIdP3
 */
export enum MethodIdP3 {
  /**
   * @generated from enum value: METHOD_ID_P3_UNKNOWN = 0;
   */
  METHOD_ID_P3_UNKNOWN = 0,

  /**
   * @generated from enum value: METHOD_ID_CREATE_GROUP = 50;
   */
  METHOD_ID_CREATE_GROUP = 50,

  /**
   * @generated from enum value: METHOD_ID_CREATE_INVITE = 51;
   */
  METHOD_ID_CREATE_INVITE = 51,

  /**
   * @generated from enum value: METHOD_ID_REVOKE_INVITE = 52;
   */
  METHOD_ID_REVOKE_INVITE = 52,

  /**
   * @generated from enum value: METHOD_ID_JOIN_CONVERSATION = 53;
   */
  METHOD_ID_JOIN_CONVERSATION = 53,

  /**
   * @generated from enum value: METHOD_ID_LEAVE_CONVERSATION = 54;
   */
  METHOD_ID_LEAVE_CONVERSATION = 54,

  /**
   * @generated from enum value: METHOD_ID_SET_MEMBER_ROLE = 55;
   */
  METHOD_ID_SET_MEMBER_ROLE = 55,

  /**
   * @generated from enum value: METHOD_ID_SET_BAN = 56;
   */
  METHOD_ID_SET_BAN = 56,

  /**
   * @generated from enum value: METHOD_ID_LIST_MEMBERS = 57;
   */
  METHOD_ID_LIST_MEMBERS = 57,

  /**
   * @generated from enum value: METHOD_ID_TRANSFER_OWNERSHIP = 58;
   */
  METHOD_ID_TRANSFER_OWNERSHIP = 58,

  /**
   * @generated from enum value: METHOD_ID_UPSERT_TOPIC = 59;
   */
  METHOD_ID_UPSERT_TOPIC = 59,

  /**
   * @generated from enum value: METHOD_ID_DELETE_TOPIC = 60;
   */
  METHOD_ID_DELETE_TOPIC = 60,

  /**
   * @generated from enum value: METHOD_ID_CREATE_POLL = 61;
   */
  METHOD_ID_CREATE_POLL = 61,

  /**
   * @generated from enum value: METHOD_ID_VOTE = 62;
   */
  METHOD_ID_VOTE = 62,

  /**
   * @generated from enum value: METHOD_ID_CLOSE_POLL = 63;
   */
  METHOD_ID_CLOSE_POLL = 63,

  /**
   * @generated from enum value: METHOD_ID_RESOLVE_JOIN_REQUEST = 64;
   */
  METHOD_ID_RESOLVE_JOIN_REQUEST = 64,

  /**
   * @generated from enum value: METHOD_ID_SET_CONVERSATION_POLICY = 65;
   */
  METHOD_ID_SET_CONVERSATION_POLICY = 65,

  /**
   * @generated from enum value: METHOD_ID_LIST_TOPICS = 130;
   */
  METHOD_ID_LIST_TOPICS = 130,

  /**
   * @generated from enum value: METHOD_ID_GET_POLL = 131;
   */
  METHOD_ID_GET_POLL = 131,

  /**
   * @generated from enum value: METHOD_ID_LIST_JOIN_REQUESTS = 132;
   */
  METHOD_ID_LIST_JOIN_REQUESTS = 132,

  /**
   * @generated from enum value: METHOD_ID_UPDATE_CONVERSATION = 133;
   */
  METHOD_ID_UPDATE_CONVERSATION = 133,
}

/**
 * Describes the enum chat.v1.MethodIdP3.
 */
export const MethodIdP3Schema: GenEnum<MethodIdP3> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p3, 0);

